/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SmsAutoDisableStatus
 */
export interface SmsAutoDisableStatus {
    /**
     * 
     * @type {string}
     * @memberof SmsAutoDisableStatus
     */
    disabled_at: string;
    /**
     * 
     * @type {string}
     * @memberof SmsAutoDisableStatus
     */
    failure_class: string;
    /**
     * 
     * @type {string}
     * @memberof SmsAutoDisableStatus
     */
    provider_response: string;
}

/**
 * Check if a given object implements the SmsAutoDisableStatus interface.
 */
export function instanceOfSmsAutoDisableStatus(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "disabled_at" in value;
    isInstance = isInstance && "failure_class" in value;
    isInstance = isInstance && "provider_response" in value;

    return isInstance;
}

export function SmsAutoDisableStatusFromJSON(json: any): SmsAutoDisableStatus {
    return SmsAutoDisableStatusFromJSONTyped(json, false);
}

export function SmsAutoDisableStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): SmsAutoDisableStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'disabled_at': json['disabled_at'],
        'failure_class': json['failure_class'],
        'provider_response': json['provider_response'],
    };
}

export function SmsAutoDisableStatusToJSON(value?: SmsAutoDisableStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'disabled_at': value.disabled_at,
        'failure_class': value.failure_class,
        'provider_response': value.provider_response,
    };
}

